<template>
    <go-edit-table :height="height"
                   :dataSource="detailList"
                   :edit="false"
                   :showCheck="false"
                   :columns="columns"
                   :pagination="false">

    </go-edit-table>
</template>

<script>
import GoEditTable from "@/components/tools/GoEditTable";
import {getAction} from "@/api/manage";
import {formatTableData} from "@/utils/Tool";

export default {
    name: "SaleHistory",
    components: {GoEditTable},
    props: {
        height: {
            type: Number
        },
        goodsId: {
            type: String,
            required: true
        },
        orderOrganizationId: {
            type: String,
            required: true
        }
    },
    data: function () {
        return {
            detailList: [],
            columns: [
                {
                    title: '类型',
                    dataIndex: 'type',
                    width: 100,
                    canEdit: false,
                    slotIgnore: false,
                },
                {
                    title: '单据日期',
                    dataIndex: 'invoicedate',
                    width: 100,
                    canEdit: false,
                    slotIgnore: false,
                },
                {
                    title: '价格类型',
                    dataIndex: 'saleType_dictText',
                    width: 100,
                    canEdit: false,
                    slotIgnore: false,
                },
                {
                    title: '数量',
                    dataIndex: 'quantity',
                    width: 100,
                    canEdit: false,
                    slotIgnore: false,
                },
                {
                    title: '单价',
                    dataIndex: 'unitPrice',
                    width: 100,
                    canEdit: false,
                    slotIgnore: false,
                },
            ],
            url: {
                list: '/base/bill/listSaleHistory'
            }
        }
    },
    computed: {
        refreshKey: function () {
            if (!this.goodsId || !this.orderOrganizationId) {
                return null
            }
            return this.goodsId + "-" + this.orderOrganizationId
        }
    },
    watch: {
        'refreshKey': {
            immediate: true,
            handler(val) {
                this.loadData()
            },
        }
    },
    methods: {
        loadData: function () {
            this.detailList = []
            getAction(this.url.list, {goodsId: this.goodsId, organizationId: this.orderOrganizationId}).then(res => {
                if (res.success) {
                    this.detailList = formatTableData(res.result)
                }
            })
        }
    }
}
</script>

<style scoped>

</style>
